const getGlobalSelectClass = (customClassNames = {}) => ({
  control: () =>
    `text-sm border-gray-300 rounded-md !shadow-none !bg-transparent !cursor-pointer 
     ${customClassNames.control || ''}`,

  menu: () =>
    `text-sm z-50 !bg-popover !text-popover-foreground
     border border-gray-200 rounded-md overflow-hidden
     ${customClassNames.menu || ''}`,

  menuList: () =>
    `max-h-60 overflow-y-auto scroll-smooth
     scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100
     hover:scrollbar-thumb-gray-500
     [&::-webkit-scrollbar]:w-2
     [&::-webkit-scrollbar-thumb]:rounded-full
     [&::-webkit-scrollbar-thumb]:bg-gray-400
     [&::-webkit-scrollbar-track]:bg-gray-100
     [&::-webkit-scrollbar-thumb:hover]:bg-gray-500
     ${customClassNames.menuList || ''}`,

  option: ({ isFocused, isSelected, isDisabled }) => {
    if (isDisabled) {
      return `
      px-3 py-2 text-sm rounded capitalize
      dark:text-gray-400 !text-gray-600
      cursor-not-allowed opacity-50
      ${customClassNames.option || ''}
    `;
    }

    return `
    !cursor-pointer px-3 py-2 text-sm rounded capitalize transition-colors
    ${isSelected
        ? '!bg-gray-200 !text-gray-700'
        : isFocused
          ? '!bg-gray-100 text-black'
          : 'bg-white text-gray-700'}
    ${customClassNames.option || ''}
  `;
  },

  placeholder: () =>
    `text-gray-400 ${customClassNames.placeholder || ''}`,

  singleValue: () =>
    `text-sm hover:!bg-transparent !text-gray-600 ${customClassNames.singleValue || ''}`,

  multiValue: () =>
    `!rounded-[50px] bg-gray-100 text-gray-700 ${customClassNames.multiValue || ''}`,

  multiValueLabel: () =>
    `!py-0 ${customClassNames.multiValueLabel || ''}`,

  multiValueRemove: () =>
    `!rounded-[50px] hover:!bg-danger-clarity hover:!text-danger ${customClassNames.multiValueRemove || ''}`,
});

export { getGlobalSelectClass };